var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mui-toggle-btn-group",
    class: [
      _vm.orientation ? ("mui-toggle-btn-group--" + _vm.orientation) : '',
      {
        'mui-toggle-btn-group--full-width': _vm.fullWidth
      }
    ],
    attrs: {
      "role": "group",
      "aria-label": _vm.ariaLabel
    }
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4d55184","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Button/ToggleButtonGroup.vue
// module id = 512
// module chunks = 0